<template>
    <span class="avatar" :style="style"></span>
</template>
<script>
  export default {
    name: 'UserImageWidget',
    props: ['image', 'color'],
    data () {
      return {
        defaultImage: '/static/images/default-avatar.svg'
      }
    },
    computed: {
      style () {
        let style = {}

        if (this.color) {
          style.borderColor = this.color
        }

        let image = this.defaultImage

        if (this.image) {
          image = this.image + '/w=100'
        }
        style.backgroundImage = 'url(' + image + ')'

        return style
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/widgets/UserImageWidget.vue